/**
 * CampaignMetrics
 *
 * Summary metric tiles with navigation to responses and starred views.
 */
import React from 'react';
import { MetricCard } from './metric-card';
import { Video, Star } from 'lucide-react';

export default function CampaignMetrics({ metrics, campaignId, navigate, campaign, currentNamespaceId }) {
  // Helper function to add namespace ID to navigation URLs
  const navigateWithNamespace = (path) => {
    // Parse the base path and any existing query parameters
    const [basePath, existingQuery] = path.split('?');
    const searchParams = new URLSearchParams(existingQuery || '');
    
    // Add namespace ID as a query parameter if available
    if (currentNamespaceId) {
      searchParams.set('namespaceId', currentNamespaceId);
    }
    
    // Construct the final URL with all query parameters
    const queryString = searchParams.toString();
    const finalPath = queryString ? `${basePath}?${queryString}` : basePath;
    
    navigate(finalPath);
  };

  return (
    <div className="mt-8 grid gap-6 grid-cols-1 sm:grid-cols-2">
      <MetricCard
        title="Campaign Responses"
        value={metrics.responses}
        icon={Video}
        onClick={() => navigateWithNamespace(`/app/campaigns/${campaignId}/responses`)}
      />
      <MetricCard
        title="Starred Videos"
        value={campaign.starredCount || 0}
        icon={Star}
        onClick={() => navigateWithNamespace(`/app/campaigns/${campaignId}/responses?starred=true`)}
      />
    </div>
  );
}